<app-page-template
  [showParent]="showParent"
  (clearQueryString)="onClearQueryString()"
  [config]="pageConfig"
  (comparisonObjects)="getComparisonObjects($event)"
  (pageNumber)="changePageNumber($event)"
  (pageSize)="changePageSize($event)"
  (comparisonObjects)="getComparisonObjects($event)"
  (onRefresh)="onReset()"
>
  <div class="card-toolbar" after-btns>
    <!-- close -->
    <a
      class="btn btn-light txt-lg button-shadow mx-1 btn-hover-rise"
      mat-ripple
      [matTooltip]="'common.back' | translate"
      (click)="onClose()"
    >
      <i class="mdi mdi-arrow-left mdi-20px p-0"></i>
    </a>
  </div>

  <div class="flex-between ml-5" recipient-count>
    (
    <span class="fw-500 text-base"
      >{{ "common.numbersCount" | translate }} :
    </span>
    <span
      copyToClipboard
      class="text-navyBlue py-1 rounded text-xl mr-2 fw-600"
      >{{ paginationModel.totalCount | numberSeparator }}</span
    >)
  </div>

  <!--------------------------------------------------------------- Table Content ---------------->
  <ng-container table-body *ngIf="items && !pageConfig.loading">
    <ng-container *ngFor="let item of items; let i = index">
      <tr
        #row
        (click)="onActiveRow(row, i)"
        [class.row-active]="rowIndexSelected == i"
        class="ml-2"
        [ngClass]="currentDateTime > item.expireDate ? 'tr-expired' : ''"
      >
        <!-- index -->
        <td class="px-4 text-center py-2">
          {{ this.paginationModel.firstIndex + i }}
        </td>

        <!-- number -->
        <td>
          <td-value
            class="font-vazir-ui"
            copyToClipboard
            [value]="item?.number"
          ></td-value>
        </td>

        <!-- smsCp -->
        <td class="py-2">
          <span>
            {{ item?.smsCp | enumToText : SmsCpEnumValues }}
          </span>
        </td>

        <!-- numberType -->
        <td class="py-2">
          <span>
            {{ item?.numberType | enumToText : NumberTypeEnumValues }}
          </span>
        </td>

        <!-- isActive -->
        <td>
          <td-value type="boolean" [value]="item?.isActive"></td-value>
        </td>

        <!-- sendToBlackList -->
        <td>
          <td-value type="boolean" [value]="item?.sendToBlackList"></td-value>
        </td>

        <!-- expireDate -->
        <td>
          <td-value type="dateTime" [value]="item?.expireDate"></td-value>
        </td>
      </tr>
    </ng-container>
  </ng-container>

  <ng-container *ngIf="!items?.length" table-body>
    <tr>
      <td colspan="100">
        <p
          class="text-center tw-text-gray-500 dark:tw-text-gray-300 my-5 text-lg dir"
        >
          {{ "common.empty" | translate }}
        </p>
      </td>
    </tr>
  </ng-container>

</app-page-template>
